import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { deepOrange, grey/*, red*/ } from '@material-ui/core/colors';
//import { motion } from 'framer-motion';
import parse from 'html-react-parser';
//import Zoom from '@mui/material/Zoom';

//models
import Message, { MessageDirection } from '../models/Message';
import { errorMessage } from '../models/Constants';

//import Grow from '@material-ui/core/Grow';

import Zoom from '@material-ui/core/Zoom';

const useStyles = makeStyles((theme) => ({
    adi: {
      //padding: theme.spacing(2),
      padding:"13px",
      maxWidth: '300px',
      color: theme.palette.getContrastText(grey[200]),
      backgroundColor: grey[200],
      //color: "#fff",
      //backgroundColor: "#304284",
      //backgroundColor:"#5c6ba7",
      borderRadius:20,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 0,
      fontWeight:400,
    },
    user: {
      //padding: theme.spacing(2),
      padding:"13px",
      maxWidth: '300px',
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
      //color:"#FFF",
      //backgroundColor:"#ff693a",
      borderRadius:20,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 0,
      fontWeight:100,
    },
    error: {
      //padding: theme.spacing(2),
      padding:"13px",
      maxWidth: '300px',
      //color: theme.palette.getContrastText(red[500]),
      color: "#fff",
      //backgroundColor: red[500],
      backgroundColor:"#f44336",
      borderRadius:20,
      borderTopRightRadius: 5,
      borderBottomLeftRadius: 0,
      fontWeight:100,
    },
  }));

const MessageBox = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message;
    if (!message.messageData) {
      //message.messageData = errorMessage[Math.floor(Math.random() * errorMessage.length)];
      message.messageData = errorMessage[crypto.getRandomValues(new Uint8Array(1))[0]];
    }
    
    if(message.messageDirection===MessageDirection.RECEIVED){
      return (
        <Zoom in={true}>
          <Paper elevation={0} className={classes.adi}>
              {parse(message.messageData)}
          </Paper>
        </Zoom>
      );
    }else if(message.messageDirection===MessageDirection.SENT) {
      return (
        <Zoom in={true}>
          <Paper className={classes.user}>
            {parse(message.messageData)}
          </Paper>
        </Zoom>
      );
    }else{
      return (
        <Zoom in={true}>
          <Paper elevation={0} className={classes.error}>
              {/* {errorMessage[Math.floor(Math.random() * errorMessage.length)]} */}
              {errorMessage[crypto.getRandomValues(new Uint8Array(1))[0]]}
          </Paper>
        </Zoom>
      );
    }
};

export default MessageBox;